export function toolIdToTranslatedKey(toolId) {
  const snakeCaseKeyToolId = toolId.replace(/[A-Z]/g, match => "_".concat(match));
  const translationKey = "".concat(snakeCaseKeyToolId.toUpperCase(), "_TITLE");
  return translationKey;
}
//# sourceMappingURL=toolIdToTranslatedKey.js.map